import store from "@/store";
import i18n from "@/i18n";
import router from "@/router";
import axios from "axios";

export function returnErrors(response: any): string {
  const accountDisabled = axios.isAxiosError(response) && response.response?.headers?.["x-account-disabled"] === "true";
  const errorStatus = response?.response?.status;
  const data = response?.response?.data;
  let message = "";

  switch (errorStatus) {
    case 400:
      if (data?.title && !data?.errors) {
        message = data.title;
      } else if (data?.error) {
        message = data.error;
      } else if (data?.errors) {
        if (Array.isArray(data.errors)) {
          for (let i = 0; i < data.errors.length; i++) {
            message +=
              data.errors[i].error +
              i18n.global.t("atRow.definition").toString() +
              data.errors[i].index +
              "\n";
          }
        } else {
          const collectedMessages: string[] = [];

          Object.entries(data.errors).forEach(([, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((msg) => {
                collectedMessages.push(msg);
              });
            }
          });

          message = collectedMessages.join("\n");
        }
      } else if (data?.message) {
        message = data.message;
      } else {
        message = JSON.stringify(data);
      }
      break;

    case 401:
      message = "Your session has expired. Please sign in again.";
      if (router.currentRoute.value.path !== "/" && !accountDisabled) {
        router.push({ path: "/" });
      }
      break;

    case 403:
      message = data?.message || data?.title || JSON.stringify(data);
      break;

    case 404:
      message = i18n.global.t("ErrorType404.definition").toString();
      break;

    case 406:
      message = data?.errorMessage || "Not Acceptable";
      break;

    case 500:
      message = i18n.global.t("ErrorType500.definition").toString();
      break;

    default:
      message = data || "An unexpected error occurred.";
      break;
  }

  store.state.loadingSpinner = false;
  return message;
}
